import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ErrorList, InputLabelWrapper } from '@guildeducationinc/recess';
import { TimePicker as AntdTimePicker } from 'antd';
import dayjs from 'dayjs';
import { uniqueId } from 'lodash';
const TIME_FORMAT = 'h:mm a';
export const TimePicker = ({ value, label, hideLabel, errors, additionalInfo, onChange, disabled, }) => {
    const inputId = uniqueId('time-picker');
    const errorList = errors ? (Array.isArray(errors) ? errors : [errors]) : [];
    const handleTimeChange = (value) => {
        onChange(value?.format(TIME_FORMAT) || '');
    };
    return (_jsxs(_Fragment, { children: [_jsx(InputLabelWrapper, { inputId: inputId, hideLabel: hideLabel, label: label, additionalInfo: additionalInfo }), _jsx(AntdTimePicker, { style: { padding: '8px 16px', border: '1px solid #636363' }, use12Hours: true, size: 'large', format: TIME_FORMAT, id: inputId, value: value ? dayjs(value, TIME_FORMAT) : null, onChange: handleTimeChange, disabled: disabled }), _jsx(ErrorList, { errors: errorList, show: errorList.length > 0, global: false })] }));
};
